import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
      {categories.map((cat) => (
        <a
          key={cat.key}
          href={cat.url}
          target="_blank"
          rel="noopener nofollow"
          className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform hover:-translate-y-0.5"
        >
          <div className="relative h-32 w-full overflow-hidden sm:h-36">
            <img
              src={cat.image}
              alt={t(`cat_${cat.key}`)}
              title={`${t('brand')} ${t(`cat_${cat.key}`)}`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            <span className="absolute bottom-2 right-2 flex h-7 w-7 items-center justify-center rounded-full bg-white/90 text-foreground-700 opacity-0 transition-opacity group-hover:opacity-100">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </span>
          </div>
          <div className="px-3 py-2.5">
            <span className="block text-sm font-semibold text-foreground-900">{t(`cat_${cat.key}`)}</span>
          </div>
        </a>
      ))}
    </div>
  );
}